import React, { useState } from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card } from '../components/ui/Card';
import { ArrowUpIcon, ArrowDownIcon, TrendingUpIcon, RefreshCwIcon } from 'lucide-react';
export function Crypto() {
  const [activeTab, setActiveTab] = useState('send');
  const cryptoAssets = [{
    name: 'Bitcoin',
    symbol: 'BTC',
    balance: '0.0542',
    value: '$2,245.67',
    change: '+3.2%'
  }, {
    name: 'Ethereum',
    symbol: 'ETH',
    balance: '1.2',
    value: '$1,850.25',
    change: '+5.1%'
  }, {
    name: 'Solana',
    symbol: 'SOL',
    balance: '12.5',
    value: '$620.80',
    change: '-2.4%'
  }, {
    name: 'Ripple',
    symbol: 'XRP',
    balance: '350',
    value: '$140.00',
    change: '+1.2%'
  }];
  return <div data-id="element-169">
      <PageHeader title="Crypto" description="Send and receive cryptocurrency" data-id="element-170" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-171">
        <div className="lg:col-span-2" data-id="element-172">
          <Card title="Crypto Assets" data-id="element-173">
            <div className="overflow-x-auto" data-id="element-174">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-175">
                <thead className="bg-gray-50" data-id="element-176">
                  <tr data-id="element-177">
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-178">
                      Asset
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-179">
                      Balance
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-180">
                      Value
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-181">
                      Change (24h)
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-182">
                  {cryptoAssets.map(asset => <tr key={asset.symbol} data-id="element-183">
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-184">
                        <div className="flex items-center" data-id="element-185">
                          <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-186">
                            {asset.symbol.substring(0, 1)}
                          </div>
                          <div className="ml-4" data-id="element-187">
                            <div className="text-sm font-medium text-gray-900" data-id="element-188">
                              {asset.name}
                            </div>
                            <div className="text-sm text-gray-500" data-id="element-189">
                              {asset.symbol}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-190">
                        <div className="text-sm text-gray-900" data-id="element-191">
                          {asset.balance}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-192">
                        <div className="text-sm text-gray-900" data-id="element-193">
                          {asset.value}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-194">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${asset.change.startsWith('+') ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-195">
                          {asset.change}
                        </span>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
        <div data-id="element-196">
          <Card title="Send & Receive" data-id="element-197">
            <div className="border-b border-gray-200" data-id="element-198">
              <nav className="-mb-px flex" aria-label="Tabs" data-id="element-199">
                <button onClick={() => setActiveTab('send')} className={`w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'send' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-200">
                  <ArrowUpIcon className="w-5 h-5 inline-block mr-2" data-id="element-201" />
                  Send
                </button>
                <button onClick={() => setActiveTab('receive')} className={`w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${activeTab === 'receive' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-202">
                  <ArrowDownIcon className="w-5 h-5 inline-block mr-2" data-id="element-203" />
                  Receive
                </button>
              </nav>
            </div>
            <div className="mt-4" data-id="element-204">
              {activeTab === 'send' ? <form className="space-y-4" data-id="element-205">
                  <div data-id="element-206">
                    <label htmlFor="crypto" className="block text-sm font-medium text-gray-700" data-id="element-207">
                      Select Crypto
                    </label>
                    <select id="crypto" name="crypto" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-208">
                      <option value="btc" data-id="element-209">Bitcoin (BTC)</option>
                      <option value="eth" data-id="element-210">Ethereum (ETH)</option>
                      <option value="sol" data-id="element-211">Solana (SOL)</option>
                      <option value="xrp" data-id="element-212">Ripple (XRP)</option>
                    </select>
                  </div>
                  <div data-id="element-213">
                    <label htmlFor="address" className="block text-sm font-medium text-gray-700" data-id="element-214">
                      Recipient Address
                    </label>
                    <input type="text" name="address" id="address" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" placeholder="Enter wallet address" data-id="element-215" />
                  </div>
                  <div data-id="element-216">
                    <label htmlFor="amount" className="block text-sm font-medium text-gray-700" data-id="element-217">
                      Amount
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-218">
                      <input type="text" name="amount" id="amount" className="focus:ring-blue-500 focus:border-blue-500 block w-full pr-12 sm:text-sm border-gray-300 rounded-md" placeholder="0.00" data-id="element-219" />
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-220">
                        <span className="text-gray-500 sm:text-sm" data-id="element-221">BTC</span>
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-222">
                    <ArrowUpIcon className="mr-2 h-5 w-5" data-id="element-223" />
                    Send Crypto
                  </button>
                </form> : <div className="space-y-4" data-id="element-224">
                  <div data-id="element-225">
                    <label htmlFor="receiveCrypto" className="block text-sm font-medium text-gray-700" data-id="element-226">
                      Select Crypto
                    </label>
                    <select id="receiveCrypto" name="receiveCrypto" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-227">
                      <option value="btc" data-id="element-228">Bitcoin (BTC)</option>
                      <option value="eth" data-id="element-229">Ethereum (ETH)</option>
                      <option value="sol" data-id="element-230">Solana (SOL)</option>
                      <option value="xrp" data-id="element-231">Ripple (XRP)</option>
                    </select>
                  </div>
                  <div data-id="element-232">
                    <label className="block text-sm font-medium text-gray-700" data-id="element-233">
                      Your Wallet Address
                    </label>
                    <div className="mt-1 flex rounded-md shadow-sm" data-id="element-234">
                      <div className="relative flex items-stretch flex-grow focus-within:z-10" data-id="element-235">
                        <input type="text" name="walletAddress" id="walletAddress" className="focus:ring-blue-500 focus:border-blue-500 block w-full rounded-none rounded-l-md sm:text-sm border-gray-300" value="1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa" readOnly data-id="element-236" />
                      </div>
                      <button type="button" className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-237">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center" data-id="element-238">
                    <div className="h-32 w-32 bg-gray-200 flex items-center justify-center" data-id="element-239">
                      <p className="text-xs text-gray-500" data-id="element-240">QR Code Here</p>
                    </div>
                    <p className="mt-2 text-sm text-gray-500" data-id="element-241">
                      Scan this QR code to receive crypto
                    </p>
                  </div>
                </div>}
            </div>
          </Card>
        </div>
      </div>
    </div>;
}